import axiosClient from "./axiosClient";

type BorrowingsQuery = {
    borrowingableType: string;
    borrowingableId: number | string;
    limit?: number;
    since?: string;
};

export const borrowingsApi = {
    getBorrowingsByItem: ({ borrowingableType, borrowingableId, limit, since }: BorrowingsQuery) => {
        const url = "api/borrowings/item";
        return axiosClient.get(url, {
            params: {
                borrowingable_type: borrowingableType,
                borrowingable_id: borrowingableId,
                limit,
                since,
            },
        });
    },
};
